export const environment = {
  production: true,
  legacyUrl: "https://webapp-uat.visiblealpha.com/app",
  legacyDomain: "https://webapp-uat.visiblealpha.com",
  apiUrl: "https://webapp-uat-insights.visiblealpha.com",
  sellsideApiUrl: "https://webapp-uat-insights.visiblealpha.com",
  assetUrl: "https://webapp-uat-cafe-cdn.visiblealpha.com/page/assets",
  showReportCenter: false,
  showZendesk: true,
  datadogRum: {
    active: false,
  },
};
